export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: true,
}
export const options = {
  vueI18n: {},
  vueI18nLoader: false,
  locales: [{"code":"gb","name":"United Kingdom","iso":"en-GB","file":"gb.json"},{"code":"au","name":"Australia","iso":"en-AU","file":"au.json"},{"code":"us","name":"United States","iso":"en-US","file":"us.json"},{"code":"default","name":"United States","iso":"en-US","file":"us.json"}],
  defaultLocale: "default",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "locales/",
  rootRedirect: null,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: false,
  pages: {"hub":false,"member":false,"member-settings":false,"subscribe":false,"fn":false,"l":false,"year-levels":{"us":"/grade-levels/"},"year-level/_slug":{"au":"/year-level/:slug","gb":"/year-level/:slug","us":"/grade-level/:slug"}},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"code":"gb","name":"United Kingdom","iso":"en-GB","file":"gb.json"},{"code":"au","name":"Australia","iso":"en-AU","file":"au.json"},{"code":"us","name":"United States","iso":"en-US","file":"us.json"},{"code":"default","name":"United States","iso":"en-US","file":"us.json"}],
  localeCodes: ["gb","au","us","default"],
  additionalMessages: [],
}
export const localeFiles = {
  0: "{",
  1: "\"",
  2: "g",
  3: "b",
  4: ".",
  5: "j",
  6: "s",
  7: "o",
  8: "n",
  9: "\"",
  10: ":",
  11: "\"",
  12: ".",
  13: ".",
  14: "/",
  15: "l",
  16: "o",
  17: "c",
  18: "a",
  19: "l",
  20: "e",
  21: "s",
  22: "/",
  23: "g",
  24: "b",
  25: ".",
  26: "j",
  27: "s",
  28: "o",
  29: "n",
  30: "\"",
  31: ",",
  32: "\"",
  33: "a",
  34: "u",
  35: ".",
  36: "j",
  37: "s",
  38: "o",
  39: "n",
  40: "\"",
  41: ":",
  42: "\"",
  43: ".",
  44: ".",
  45: "/",
  46: "l",
  47: "o",
  48: "c",
  49: "a",
  50: "l",
  51: "e",
  52: "s",
  53: "/",
  54: "a",
  55: "u",
  56: ".",
  57: "j",
  58: "s",
  59: "o",
  60: "n",
  61: "\"",
  62: ",",
  63: "\"",
  64: "u",
  65: "s",
  66: ".",
  67: "j",
  68: "s",
  69: "o",
  70: "n",
  71: "\"",
  72: ":",
  73: "\"",
  74: ".",
  75: ".",
  76: "/",
  77: "l",
  78: "o",
  79: "c",
  80: "a",
  81: "l",
  82: "e",
  83: "s",
  84: "/",
  85: "u",
  86: "s",
  87: ".",
  88: "j",
  89: "s",
  90: "o",
  91: "n",
  92: "\"",
  93: "}",
}

export const localeMessages = {
  'gb.json': () => import('../../locales/gb.json' /* webpackChunkName: "lang-gb.json" */),
  'au.json': () => import('../../locales/au.json' /* webpackChunkName: "lang-au.json" */),
  'us.json': () => import('../../locales/us.json' /* webpackChunkName: "lang-us.json" */),
}
